import React, { createContext, useState } from "react";
import { toast } from "react-toastify";

import NotificationRepository from "../../Repositories/NotificationRepository";
import errors from "../../Utils/ExtractErrors";

interface IProps {

}

export interface IMenuContextState {
    notificationsCount: number;
    notificationsLoading: boolean;
    loadNotifications: () => void;
}

const initialState: IMenuContextState = {
    notificationsCount: 0,
    notificationsLoading: true,
    loadNotifications: () => { }
}

const MenuContext = createContext<IMenuContextState>(initialState);

function MenuContextProvider({ children }: React.PropsWithChildren<IProps>) {
    const [state, setState] = useState<IMenuContextState>(initialState);

    async function loadNotifications() {
        try {
            const notificationsCount = await NotificationRepository.Count();
            setState(state => ({ ...state, notificationsCount, notificationsLoading: false }));
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });

            setState(state => ({ ...state, notificationsLoading: false }));
        }
    }

    return (
        <MenuContext.Provider value={{
            ...state,
            loadNotifications
        }}>
            {children}
        </MenuContext.Provider>
    );
}

export { MenuContext, MenuContextProvider };
